(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WalletConnectAlephiumProvider", [], factory);
	else if(typeof exports === 'object')
		exports["WalletConnectAlephiumProvider"] = factory();
	else
		root["WalletConnectAlephiumProvider"] = factory();
})(this, () => {
return 